import OrganizationDesktopMenu from "./organizationDesktopMenu";

export default OrganizationDesktopMenu;